import { memo } from 'react';
import { useParams } from 'react-router-dom';
import { EquipmentMenus as AdminEquipmentMenus } from '@/admin-pages/EquipmentMenus/EquipmentMenus';

export default memo(function PaletteContainers() {
  const { orgId } = useParams<{ orgId: string }>();
  return (
    <AdminEquipmentMenus orgId={Number(orgId)} />
  );
});
